import { Link, useLocation } from "react-router-dom"
import "./breadcrumbs.css"

export function Breadcrumbs({ dynamicPath }) {
    const location = useLocation()
    const pathnames = location.pathname.split("/").filter(x => x)

    return (
        <div className="breadcrumbs my-5">
            <div className="d-flex gap-3 align-items-center">
                <Link to="/">
                    Home
                </Link>
                
                {
                    pathnames.map((path, i) => {
                        const last = (i === pathnames.length - 1);
                        const to = `/${pathnames.slice(0, i + 1).join("/")}`
                        const title = path

                        return (
                            <div key={i} className="d-flex align-items-center gap-3">
                                <div>/</div>
                                {
                                    last ? (
                                        <div className="text-black">
                                            {dynamicPath ? dynamicPath : title}
                                        </div>
                                    ) : (
                                        <Link key={to} to={to}>{title.charAt(0).toUpperCase() + title.slice(1)}</Link>
                                    )
                                }
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
}